module.exports = __webpack_public_path__ + "img/b.26a0e5ca.jpg";